import {
  AppBar,
  Avatar,
  Button,
  Drawer,
  IconButton,
  Link,
  makeStyles,
  MenuItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import MenuIcon from '@mui/icons-material/Menu';
import { Grid, Hidden } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Login } from "../login/Login";
import { ROLE } from "../util/constant";

const headersData = [
  {
    label: "System Dashboard",
    roles: 'ANY',
    href: "/dashboard",
  },
  /*
    {
      label: "My dashboard",
      isSecured: false,
      href: "/my-dashboard",
    },
  */
  {
    label: "Admin",
    roles: [ROLE.ADMIN],
    href: "/admin-actions",
  },
  {
    label: "Manage",
    roles: 'ANY',
    href: "/manage",
  },
  {
    label: "Open Trades",
    roles: 'ANY',
    href: "/open-trades",
  },
  {
    label: "Near 52W High",
    roles: 'ANY',
    href: "/near-52w-high",
  },
  {
    label: "Manual Trigger",
    roles: 'ANY',
    href: "/manual-trigger",
  },
  {
    label: "Demat Profile",
    roles: 'ANY',
    href: "/demat-profile",
  },
  {
    label: "Watch List",
    roles: 'ANY',
    href: "/watchList",
  },
  {
    label: "FnO Entry",
    roles: [ROLE.ADMIN, ROLE.FNO_ADMIN],
    href: "/fnoEntry",
  },
  {
    label: "FnO",
    roles: [ROLE.ADMIN, ROLE.FNO_ADMIN],
    href: "/fnoControlCentre",
  },
  {
    label: "FnO Logs",
    roles: [ROLE.ADMIN, ROLE.FNO_ADMIN],
    href: "/fnoLogs",
  },
  {
    label: "Place Trade",
    roles: [ROLE.DS_EDIT],
    href: "/place-super-order",
  },
/*
  {
    label: "Broker Profile",
    roles: 'ANY',
    href: "/broker-profile",
  },
*/
  /*{
    label: "Contact Us",
    href: "/contact-us",
  },
*/  {
    label: "Logout",
    roles: 'ANY',
    href: "/logout",
  },
];

const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: "#1976d2",
    paddingRight: "20px",
    paddingLeft: "10px",
    "@media (max-width: 900px)": {
      paddingLeft: 0,
    },
  },
  logo: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "#FFFEFE",
    textAlign: "left",
  },
  menuButton: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    fontSize: 11,
    marginLeft: 20,
  },
  selectedMenuButton: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    backgroundColor: "#75ace4",
    border: "1px solid rgb(1, 1, 1)",
    fontSize: 14,
    marginLeft: 25,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  drawerContainer: {
    padding: "20px 30px",
  },
  iconButtonLabel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: "space-between",
  },
}));

export default function ButtonAppBar({ user, setUser }) {
  const isUserLoggedIn = Object.keys(user).length > 0

  const { header, logo, menuButton, selectedMenuButton, toolbar, drawerContainer} = useStyles();

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const [selectedButton, setSelectedButton] = useState();

  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, [mobileView]);

  const displayDesktop = () => {
    return (
      <Toolbar className={toolbar} variant={"dense"}>
        <Box>
          {femmecubatorLogo}
          <Typography style={{ fontSize: '.6rem' }}>Rule based unemotional investment system</Typography>
        </Box>
        <Hidden mdDown>
          <Box />
          <Box />
          <Box />
          <Box />
          <Box />
          <Box />
          <Grid item paddingBottom={1}>
            <Login user={user} setUser={setUser} />
          </Grid>
          {!isUserLoggedIn &&
            <Grid item>
              <Button variant='contained' color='default'><Link component={RouterLink} to='/signup'>Sign Up</Link></Button>
            </Grid>
          }
        </Hidden>
        <div>{getMenuButtons()}</div>
        {user && user.name && (
          <>
            <div align="right"><Typography variant="h6" component="div">{user.name.split(" ")[0]}</Typography></div>
            <div><Avatar src={user.picture} alt="User pic" /></div>
          </>)
        }
      </Toolbar>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <Toolbar>
        <IconButton
          {...{
            edge: "start",
            color: "inherit",
            "aria-label": "menu",
            "aria-haspopup": "true",
            onClick: handleDrawerOpen,
          }}
        >
          <MenuIcon />
        </IconButton>

        <Drawer
          {...{
            anchor: "left",
            open: drawerOpen,
            onClose: handleDrawerClose,
            onClick: handleDrawerClose,
          }}
        >
          <div className={drawerContainer}>{getDrawerChoices()}</div>
        </Drawer>

        <div>{femmecubatorLogo}</div>
        {user && user.name && (
          <>
            <div style={{ paddingLeft: 50 }}>
              <Typography variant="h6" component="div">{user.name}</Typography>
            </div>
            <div><Avatar src={user.picture} alt="User pic" /></div>
          </>)
        }
      </Toolbar>
    );
  };

  const getDrawerChoices = () => {
    return headersData.filter(shouldShowMenuButton)
      .map(({ label, href, isSecured }) => {
        return (
          // isSecured && !user?.isAdmin ? null :
          <Link
            {...{
              component: RouterLink,
              to: href,
              color: "inherit",
              style: { textDecoration: "none" },
              key: label,
            }}
          >
            <MenuItem>{label}</MenuItem>
          </Link>
        );
      });
  };

  const femmecubatorLogo = (
    <Typography variant="h6" component="h1" className={logo}>
      <Link {...{
        component: RouterLink,
        to: '/',
        color: "inherit",
        style: { textDecoration: "none" },
      }}
      >Algo Trading</Link>
    </Typography>
  );

  const selectMenu = (selectedButton) => {
    setSelectedButton(selectedButton);
  }
  const getMenuButtons = () => {
    return headersData.filter(shouldShowMenuButton)
      .map(({ label, href, isSecured }) => {
        return (
          // isSecured && !user?.isAdmin ? null :
          <Button
            {...{
              key: label,
              color: "inherit",
              to: href,
              component: RouterLink,
              className: selectedButton === href ? selectedMenuButton : menuButton,
            }}
            onClick={() => selectMenu(href)}
            key={href}
          >
            {label}
          </Button>
        );
      });
  };

  const shouldShowMenuButton = menu => {
    if (!menu?.roles)
      return true
    if (isUserLoggedIn && menu?.roles === 'ANY')
      return true
    return menu?.roles?.includes?.(user?.role)
  }

  return (
    <header>
      <AppBar className={header} position="relative">
        {mobileView ? displayMobile() : displayDesktop()}
      </AppBar>
    </header>
  );
}
